var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from "~/core/decorator";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import ViewAttachList from "~/components/common/view-attach-list.vue";
import { namespace } from "vuex-class";
import { PageService } from '~/utils/page.service';
var CollectionExecutionModule = namespace("collection-execution");
var RepaymentPlan = /** @class */ (function (_super) {
    __extends(RepaymentPlan, _super);
    function RepaymentPlan() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.fileDataSet = [];
        _this.dialog = {
            fileList: false
        };
        _this.fileIds = "";
        return _this;
    }
    RepaymentPlan.prototype.queryInfo = function (id) {
        var _this = this;
        this.caseOperatorPageService.queryRepaymentPlan(id, this.pageService).subscribe(function (data) { return _this.dataSet = data; });
    };
    RepaymentPlan.prototype.activated = function () {
        if (this.caseId)
            this.queryInfo(this.caseId);
    };
    __decorate([
        Dependencies(PageService)
    ], RepaymentPlan.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], RepaymentPlan.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], RepaymentPlan.prototype, "caseId", void 0);
    RepaymentPlan = __decorate([
        Component({
            components: {
                ViewAttachList: ViewAttachList
            },
        })
    ], RepaymentPlan);
    return RepaymentPlan;
}(Vue));
export default RepaymentPlan;
